import { useState, useEffect } from 'react'

/** 与设置页一致：系统设置在 localStorage 的 key */
const SYSTEM_STORAGE_KEY = 'asset_settings_system'

/** 数据刷新频率选项对应的毫秒数，realtime 表示不轮询 */
const DATA_REFRESH_MS: Record<string, number | null> = {
  realtime: null,
  '5min': 5 * 60 * 1000,
  '15min': 15 * 60 * 1000,
  '30min': 30 * 60 * 1000,
  '1hour': 60 * 60 * 1000,
}

/**
 * 从系统设置中读取「数据刷新频率」，返回轮询间隔（毫秒）。
 * - realtime：返回 null，表示不自动轮询。
 * - 5min/15min/30min/1hour：返回对应毫秒数。
 * 设置来源：设置页保存后写入 localStorage（asset_settings_system）。
 */
export function useDataRefreshInterval(): number | null {
  const [intervalMs, setIntervalMs] = useState<number | null>(() => {
    try {
      const raw = localStorage.getItem(SYSTEM_STORAGE_KEY)
      if (!raw) return null
      const data = JSON.parse(raw) as { dataRefresh?: string }
      const key = data?.dataRefresh ?? 'realtime'
      return DATA_REFRESH_MS[key] ?? null
    } catch {
      return null
    }
  })

  // 监听同源其他标签页或本页保存设置后的变化
  useEffect(() => {
    const read = () => {
      try {
        const raw = localStorage.getItem(SYSTEM_STORAGE_KEY)
        if (!raw) {
          setIntervalMs(null)
          return
        }
        const data = JSON.parse(raw) as { dataRefresh?: string }
        const key = data?.dataRefresh ?? 'realtime'
        setIntervalMs(DATA_REFRESH_MS[key] ?? null)
      } catch {
        setIntervalMs(null)
      }
    }

    window.addEventListener('storage', read)
    return () => window.removeEventListener('storage', read)
  }, [])

  return intervalMs
}
